<template>
  <div id="roomList">
    <div v-if="availableRoom == 0 && isBE && roomsReady">
        <p>{{ strings.thereAreNoRoomWithCriteria }}</p>
    </div>
    <div v-if="(availableRoom != 0 || !isBE) && roomsReady">
        <h3>{{ strings.choosearoom }}</h3>
        <p v-if="selectedLang !== 'de'" class="small"> <strong>{{ availableRoom }} {{ strings.outof }} {{numRoom}}</strong> {{ strings.rooms }} {{ strings.suitablecriteria }}.</p>
    </div>
    <!-- Customized radio buttons -->
    <p class="loading-indicator" v-show="roomsReady == false && isBE && !isMoreThanOneDay">
        <pulse-loader :color="'#9d9d9d'"></pulse-loader>
    </p>
    <MPDiscountCodeBlock v-if="!isBE" />
    <form v-if="!useNewVenuePage" class="radio">
        <MPRoomItem 
        :id="item.id" 
        v-for="(item, key) in roomList"
        v-show="key < x"
        :key="key"
        :title="item.title"
        :instantBookable="item.instant_bookable"
        :roomMin="item.min"
        :roomMax="item.max"
        :roomPriceVat="item.calculated_prices.price_vat"       
        :correctPrice="item.correct_price"
        :roomHalfDay="item.calculated_prices.halfday_price"
        :roomFullDay="item.calculated_prices.fullday_price"
        :roomDescription="item.description == null ? '' : item.description.value"
        :roomLayout="item.room_layout"
        :roomLayoutOriginal="item.room_layout_original"
        :roomHeight="item.height"
        :roomWidth="item.width"
        :roomLength="item.length"
        :roomArea="item.area"
        :roomEquipment="item.equipment_name"
        :roomEquipmentFee="item.equipment_fee_name"
        :packages="item.packages"
        :priceType="item.calculated_prices.type"
        :chosenPriceType="item.chosen_price"
        :available="item.is_smart_space == true ? true : item.available"
        :exceed="item.exceed"
        :isSmartSpace="item.is_smart_space == true"
        :minRevenue="item.min_revenue ? item.min_revenue : 0"
        :demand="item.demand ? item.demand : ''"
        :valid_layout="item.valid_layout"
        :no_layout="item.no_layout"
        :image="item.room_pictures"
        :selected_room="selected_room"
        :day="day"
        :threeSixtyView="item.room_360_view"
        :mt_length="mt_length"
        :position="key"
        />

    </form>
    <form v-else class="radio">
        <MPRoomAndPackageItem
        :id="item.id" 
        v-for="(item, key) in roomList"
        v-show="key < x"
        :key="key"
        :title="item.title"
        :instantBookable="item.instant_bookable"
        :roomMin="item.min"
        :roomMax="item.max"
        :roomPriceVat="item.calculated_prices.price"       
        :correctPrice="item.correct_price"
        :roomHalfDay="item.calculated_prices.halfday_price"
        :roomFullDay="item.calculated_prices.fullday_price"
        :roomDescription="item.description == null ? '' : item.description.value"
        :roomLayout="item.room_layout"
        :roomLayoutOriginal="item.room_layout_original"
        :roomHeight="getRoomDimensions(item.height)"
        :roomWidth="getRoomDimensions(item.width)"
        :roomLength="getRoomDimensions(item.length)"
        :roomArea="getRoomDimensions(item.area, true)"
        :roomEquipment="item.equipment_name"
        :roomEquipmentFee="item.equipment_fee_name"
        :packages="item.packages"
        :priceType="item.calculated_prices.type"
        :chosenPriceType="item.correct_price.type"
        :available="item.is_smart_space == true ? true : item.available"
        :exceed="item.exceed"
        :isSmartSpace="item.is_smart_space == true"
        :minRevenue="item.min_revenue ? item.min_revenue : 0"
        :demand="item.demand ? item.demand : ''"
        :valid_layout="item.valid_layout"
        :no_layout="item.no_layout"
        :image="item.room_pictures"
        :selected_room="selected_room"
        :day="day"
        :threeSixtyView="item.room_360_view"
        :mt_length="mt_length"
        :position="key"
        :isWebBookable="item.room_online"
        />

    </form>

    <a href="" class="button full-on-mobile" :class="{'nchShowMore': isNCH }" @click.prevent="showMore()" v-if="showMoreStatus">{{ strings.showmore }} {{ strings.rooms }} ({{roomLeft}})</a>
    <a href="" v-scroll-to="'#roomList'" class="button full-on-mobile" :class="{'nchShowMore': isNCH }" @click.prevent="showLess()" v-if="showFewerStatus && selectedLang == 'de'">Weniger Tagungsräumen anzeigen </a>
    <a href="" v-scroll-to="'#roomList'" class="button full-on-mobile" :class="{'nchShowMore': isNCH }" @click.prevent="showLess()" v-if="showFewerStatus && selectedLang != 'de'">{{ strings.showfewer }} {{ strings.rooms }}</a>
  </div>
</template>

<script>
import MPRoomItem from './RoomItem';
import MPRoomAndPackageItem from './RoomAndPackageItem';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import MPDiscountCodeBlock from './DiscountCodeBlock'
import * as dataLayer from '../assets/misc/dataLayer.js';
import moment from "moment";
import * as hf from '../assets/misc/helperFunctions.js'

export default {
    props: [
        'rooms',
        'selected_room',
        'day',
        'mt_length'
    ],
    watch: {
        roomList(newValue){
            dataLayer.pushViewItemList(this.prepareDatalayerItems());
        },
        selectedRoomIndex(newValue) {
            let roomLength = this.$store.state.roomInfo.length;
            let selectedRoom = this.$store.state.selectedRoom;
            if(newValue >= 5){
                this.x = roomLength;
            }
            setTimeout(() => {
                this.$scrollTo('.room_' + selectedRoom);
            }, 50);
        },
        availableRoom(newValue) {
            if (newValue > oldValue) {
                if (newValue < 5) {
                    this.x = newValue
                } else {
                    this.x = 5
                }
            } else {
                if (this.x > newValue) {
                    this.x = newValue
                }
            }
            this.roomLeft = newValue - this.x;
        }
    },
    data () {
        return {
            x: 5,
            step: 5,
            roomLeft: ''
        }
    },
    components: {
        MPRoomItem,
        PulseLoader,
        MPDiscountCodeBlock,
        MPRoomAndPackageItem
    },
    computed: {
        isBE() {
            return this.$store.state.isBE;
        },
        useNewVenuePage() {
            return this.$store.state.useNewVenuePage
        },
        selectedLang () {
            return this.$store.state.selectedLang;
        },
        isMoreThanOneDay(){
            return this.$store.state.isMoreThanOneDay;
        },
        isNCH(){
            return this.$store.state.isNCH;
        },
        roomList() {
            if(this.isMoreThanOneDay){
                return this.rooms;
            } else {
                return this.$store.state.roomInfo;
            }
            
        },
        packageList() {
            return this.$store.state.packageInfo
        },
        showMoreStatus() {
            let isBE = this.$store.state.isBE;
            let roomLength = '';
            if(isBE){
                roomLength = this.availableRoom;
            } else {
                roomLength = this.$store.state.roomInfo.length;
            }
            if(this.x >= roomLength){
                return false;
            } else {
                return true;
            }
        },
        showFewerStatus() {
            let isBE = this.$store.state.isBE;
            let roomLength = '';
            if(isBE){
                roomLength = this.availableRoom;
            } else {
                roomLength = this.$store.state.roomInfo.length;
            }
            this.roomLeft = roomLength - this.x;
            if(this.x == roomLength && roomLength > 5){
                return true;
            } else {
                return false;
            }
        },
        numRoom() {
            if(this.isMoreThanOneDay){
                return this.rooms.length;
            } else {
                return this.$store.state.roomInfo.length;
            }
        },
        availableRoom() {
            let discount_code = this.$cookie.get('discount_code');
            let is_discount_code_valid = false
            let route = this.$route;
            let roomList = [];
            if(this.isMoreThanOneDay){
                roomList = this.rooms;
            } else {
                roomList = this.$store.state.roomInfo;
            }
            let count = 0;

            if(roomList){
                if (discount_code) {
                    let arePackagesDiscounted = false
                    let areRoomsDiscounted = roomList.some(room => room.calculated_prices.type == 'disc_price')
                    
                    if (this.packageList) {
                        arePackagesDiscounted = this.packageList.some(pkg => pkg.correct_price?.price_category === 'disc_price')
                    }
    
                    if(areRoomsDiscounted || arePackagesDiscounted){
                        // Valid discount code applied
                        this.$store.commit('showDiscPriceError', false);
                        is_discount_code_valid = true
                    } else {
                        // Invalid discount code applied
                        setTimeout(() => {
                            this.$cookie.set('discount_code', '');
                            this.$store.commit('showDiscPriceError', true);
                        }, 100);
                    }
                } else {
                    // No discount code applied
                    this.$store.commit('showDiscPriceError', false);
                    is_discount_code_valid = false
                }
                
                roomList.forEach(element => {
                    let isWebBookable = false
                    let roomPackages = this.packageInfo.filter(pack => {
                        const minDelegateToCheck = parseInt(element.min) < parseInt(pack.package_min) ? parseInt(pack.package_min) : parseInt(element.min)
                        const maxDelegateToCheck = parseInt(element.max) > parseInt(pack.package_max) ? parseInt(pack.package_max) : parseInt(element.max)
                        if (parseInt(this.s_delegates) < minDelegateToCheck || parseInt(this.s_delegates) > maxDelegateToCheck) {
                            return false
                        }
                        return pack.rooms.some(room => room.id === element.id)
                    })
                    const doesRoomHavePackage = roomPackages.length > 0
                    let roomRentalDiscountedCheck = true
                    let packageDiscountedCheck = true
                    let discountedRoomCheck = true
                    
                    if (is_discount_code_valid) {
                        // Non-discounted rooms are now supposed to be hidden
                        roomRentalDiscountedCheck = element.correct_price?.price_category === "disc_price"
                        packageDiscountedCheck = roomPackages.some(packageItem => packageItem.correct_price?.price_category === "disc_price")
                        discountedRoomCheck = roomRentalDiscountedCheck || packageDiscountedCheck
                    }

                    // Check for non web bookable room
                    if (this.showRatesFilter == 'roomRental') {
                        isWebBookable = element.room_online && roomRentalDiscountedCheck
                    } else if (this.showRatesFilter == 'packages') {
                        isWebBookable = doesRoomHavePackage && packageDiscountedCheck
                    } else { // "All" case
                        if (doesRoomHavePackage) 
                            isWebBookable = discountedRoomCheck
                        else 
                            isWebBookable = element.room_online && discountedRoomCheck
                    }

                    if (
                        element.available && 
                        element.exceed == 'no' && 
                        element.valid_layout && 
                        isWebBookable
                    ) {
                        count++;
                    }
                });
 
                let minRoomNum = this.$store.state.minRoomNum;
                if(minRoomNum == '' || typeof minRoomNum == 'undefined'){
                    minRoomNum = 10;
                }
                if(!this.$cookie.get('_pref_qty') && count == 0 && !route.query.delegates){ 
                    this.$store.commit('setDelegates', minRoomNum);
                    this.$cookie.set('_pref_qty', minRoomNum);
                    
                    this.$store.dispatch('sortRoomList');
                    if(this.checkAvailable() > 0){
                        this.$store.commit('setRoomFormDisabled', 'no');
                    } else {
                        this.$store.commit('setRoomFormDisabled', 'yes');
                    }      
                } else if(!this.$cookie.get('_pref_qty') && count != 0 && !route.query.delegates){
                    this.$store.commit('setRoomFormDisabled', 'no');
                } else {
                    if(count == 0){
                        this.$store.commit('setRoomFormDisabled', 'yes');
                    } else {
                        this.$store.commit('setRoomFormDisabled', 'no');
                    }
                }
            }
            return count;
        },
        shouldHide() {
            return this.$store.state.isRoomFormDisabled;
        },
        strings () {
	        return this.$store.state.strings
        },
        selectedRoomIndex() {
            return this.$store.state.selectedRoomIndex;
        },
        isOpera() {
            return this.$store.state.isOpera;
        },
        roomsReady() {
            return this.$store.state.roomsReady;
        },
        isBE() {
            return this.$store.state.isBE;
        },
        showRatesFilter() {
            return this.$store.state.showRatesFilter;
        },
        packageInfo() {
            return this.$store.state.packageInfo;
        },
        s_delegates() {
            return this.$store.state.delegates;
        },
    },
    methods: {
        showMore() {
            let isBE = this.$store.state.isBE;
            let roomLength = '';
            if(isBE){
                roomLength = this.availableRoom;
            } else {
                roomLength = this.$store.state.roomInfo.length;
            }
            this.x = this.x + this.step <= roomLength ? this.x + this.step : roomLength;
            this.roomLeft = roomLength - this.x;
            let roomList = [];
            if(this.isMoreThanOneDay){
                roomList = this.rooms;
            } else {
                roomList = this.$store.state.roomInfo;
            }

        },
        showLess() {
            let isBE = this.$store.state.isBE;
            let roomLength = '';
            if(isBE){
                roomLength = this.availableRoom;
            } else {
                roomLength = this.$store.state.roomInfo.length;
            }
            this.x = 5;
            this.roomLeft = roomLength - this.x;
            let roomList = [];
            if(this.isMoreThanOneDay){
                roomList = this.rooms;
            } else {
                roomList = this.$store.state.roomInfo;
            }
        },
        checkAvailable() {
            let roomList = this.$store.state.roomInfo;
            let count = 0;
            if(roomList){
                roomList.forEach(element => {
                    if( (element.available && element.exceed == 'no' && element.valid_layout) || element.is_smart_space == true){
                        count++;
                    }
                });
            }
            return count;
        },

        prepareDatalayerItems(){
            let items = [];
            let layout = hf.getLayoutName(this.$store.state.selectedLayout);
            let venue_info = this.$store.state.venueInfo;
            let delegates = this.$store.state.delegates;
            let meetingStartTime = moment(this.$store.state.datetime, 'DD-MM-YYYY HH:mm');
            let meetingEndTime = moment(this.$store.state.endDatetime, 'DD-MM-YYYY HH:mm');
            let meetingDuration = moment.duration(meetingEndTime.diff(meetingStartTime));
            let hours = meetingDuration.hours();
            let days =  meetingDuration.days();
            let duration_type = "other";
            if (days === 0 && hours <= 5) {
                duration_type = "half_day";
            } else if (days === 0 && hours > 5) {
                duration_type = "full_day";
            } else if (days > 0 ) { 
                duration_type = "multi_day";
                hours = hours + (days * 24);
            }
            let quantity = 1;
            items.push({
                "item_id" : venue_info.id,
                "item_name" : venue_info.title,
                 //"item_brand": venue_info.title +  "- " + venue_info.id, //Product Brand       
                "item_variant": duration_type, //Event type e.g. full-day, half-day or other
                //"item_category": type, //package or meeting room depending on the product clicked
                "item_category2": venue_info.venue_type, //Venue type
                "item_category3": layout == '_none' ? 'anything_goes': layout, //Meeting room seating layout
                //"item_category4": order_type, //Order type (instant, priced or enquiry)
                "item_category5": hours, //product meeting length
                "item_city": venue_info.city,  //City of the venue    
                "item_country": venue_info.country_code, //Country of the venue
                "item_start_date": meetingStartTime.format('YYYY-MM-DD HH:mm:ss'), //Event start time 
                "item_end_date": meetingEndTime.format('YYYY-MM-DD HH:mm:ss'), //Event end time
                "item_delegates": parseInt(delegates), //Number of delegates
                "item_list_name": 'Venue', //Search or Venue (Based on first list visited during the session)
                "quantity" : quantity,
                "price": 0
             });
 
            return items;
        },
        getRoomDimensions(value, isAreaDimension = false){
            if (this.selectedLang != 'en-us') return value
            const conversionRatio = 3.28084
            return isAreaDimension ? (Number(value)*(conversionRatio**2)).toFixed(2) : (Number(value)*conversionRatio).toFixed(2)
        }
    }
}
</script>
<style scoped>
.nchShowMore{
    background: transparent!important;
    border: 1px solid #002f3d!important;
    color: #002f3d!important;
    border-radius: initial!important;
    font-weight: 400!important;
    font-size: 18px!important;
    padding: 8px 20px 3px 20px!important;
    line-height: 1.5!important;
}
.nchShowMore:hover{
    background-color: #002f3d!important;
    color: #fff!important;
    text-decoration: none!important;
}
</style>
